import { css } from '@emotion/css'
import { spacing, borderRadius } from '../../styles'
import { getSkeletonColors } from '../../themes'

const styles = {
  wrapper: css({
    display: 'flex',
    alignItems: 'center',

    '& > * + *': {
      marginLeft: spacing.default,
    },
  }),

  checkbox: css({
    display: 'block',
    width: 20,
    height: 20,
    borderRadius: borderRadius.default,
  }),
}

export default styles

export const checkboxTheme = theme =>
  css({
    backgroundColor: getSkeletonColors(theme),
  })
